<!--
difference between RadioButtonBase and RadioBase
  1. Replaced v-radio with v-btn
  2. added getValue() click event to v-btn
  3. getValue() targets the buttons text and assigns to the question.Value
  4. the styles used here should ONLY be used for this component
 -->
<template>
  <div :class="[question.StyleClass, question.Source?.toLowerCase()]">
    <HomeBaseLabel :question="question" :class="[question?.LabelStyleClass]" />
    <div
      v-if="question?.Description"
      class="d-flex align-left flex-no-wrap font-14 btn-description"
    >
      {{ question.Description }}
    </div>
    <v-radio-group
      row
      :hide-details="isDisabled ? 'true' : 'auto'"
      class="radioButton mt-n4"
      :data-uiid="question.DataUiid"
      v-model="computedQuestion.Value"
      :rules="getRules"
      :aria-label="question?.Description ?? ''"
      ref="radioGroup"
    >
      <v-btn
        v-for="(option, index) in question.Options"
        :disabled="isDisabled"
        :key="index"
        :ripple="false"
        outlined
        :min-width="question.ButtonWidth ? question.ButtonWidth : 100"
        max-width="100%"
        class="font-20 flex-shrink-0 mt-4 mr-4 text-capitalize radiobutton--text"
        large
        rounded
        :class="[
          question.Value === convertToStrings(option.Value)
            ? 'radioButton--active'
            : '',
          question?.ButtonStyleClass,
        ]"
        :data-uiid="option.DataUiid"
        @click="getValue(option)"
        :aria-label="option?.Text ?? ''"
        >{{ option.Text }}</v-btn
      >
    </v-radio-group>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import { DEFAULTED } from "@/constants/common.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";

export default {
  name: "RadioButtonBase.vue",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "ncdBuildingsState",
      "getQuestionValueByInterfaceKey",
    ]),
    isDisabled() {
      return (
        (this.question.InterfaceKey === "NoClaimsBuildings" &&
          this.ncdBuildingsState === DEFAULTED) ||
        this.disabled
      );
    },
    computedQuestion: {
      get() {
        return Object.assign({}, this.question);
      },
      set(newVal) {
        return newVal;
      },
    },
  },
  watch: {
    // watching the question by turing into computed will give the old and new value, otherwise both values will be the same;
    //https://vuejs.org/guide/essentials/watchers.html#deep-watchers
    computedQuestion: {
      handler: function (newVal, oldVal) {
        this.$emit("radioButtonBaseChange", {
          new: newVal,
          old: oldVal,
          radioGroupRef: this.$refs.radioGroup,
        });
      },
      deep: true,
    },
  },
  methods: {
    getValue(option) {
      this.$emit("radioButtonBaseClick");
      this.question.Value = this.convertToStrings(option.Value);
      this.question.Source = "User";
    },
    convertToStrings(value) {
      return value.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-description {
  letter-spacing: 0.4px;
  margin-bottom: 8px;
  max-width: 665px;
  color: #272727 !important;
}
.label {
  margin-top: 34px !important;
  margin-bottom: 4px !important;
}
.document-preference {
  margin-top: -13px;
}
.document-preference-label {
  margin-bottom: 4px !important;
}
@media screen and (max-width: 992px) {
  .label {
    margin-bottom: 12px !important;
  }
}
.v-btn:disabled {
  opacity: 0.6;
  background-color: #f3f3f3;
}
.delivery-preference {
  width: 141.7px !important;
  height: 48px !important;
}
.small-button {
  height: 48px !important;
}
</style>
